/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseReferentialVariable } from '../../models/api-response-referential-variable';
import { ReferentialVariable } from '../../models/referential-variable';

export interface CreateReferentialVariable$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: ReferentialVariable
}

export function createReferentialVariable(http: HttpClient, rootUrl: string, params: CreateReferentialVariable$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseReferentialVariable>> {
  const rb = new RequestBuilder(rootUrl, createReferentialVariable.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseReferentialVariable>;
    })
  );
}

createReferentialVariable.PATH = '/v1/api/admin-ui/referential/variable';
